import { Alert } from '@material-ui/lab';
import React from 'react';
import JSONInput from 'react-json-editor-ajrm';
import { BackButton, PrimaryButton, TextField } from '../../components/AtomComponents';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { fetchData } from '../../_lib/lib';
import { localeEn } from '../ConfigTenant/ConfigTenant';
import { checkForSuccesInvocation, isEmail } from '../../_lib/utils';
import apiToUrlMap from '../../ApiMapping';
import { Wait } from '../SchemaSync/SchemaSync';
import { useConfirm } from '../../context/ConfirmContext';

const ResendCognitoEmail = () => {
  const { confirm } = useConfirm();
  const [tenantId, setTenantId] = React.useState('');
  const [tenantEmail, setTenantEmail] = React.useState('');
  const [processState, setProcessState] = React.useState<number>(0);
  const [previewState, setPreviewState] = React.useState<any>(null);
  const { openSnackBar } = useDataService();

  const sendEmail = async () => {
    setProcessState(1);
    const res: any = await fetchData('POST', apiToUrlMap.resendCognitoActivationEmail, {
      body: { tenant_id: tenantId, receiverEmail: tenantEmail },
    });
    if (!res.error) {
      try {
        checkForSuccesInvocation(res, setPreviewState, setProcessState);
      } catch (e: any) {
        openSnackBar(e.message || 'Something went wrong, unable to send email.', eMessageType.error);
      }
    } else {
      setPreviewState(null);
      setProcessState(0);
      openSnackBar('Email not sent.', eMessageType.error);
    }
  };
  return (
    <>
      <div className="cell small-6 medium-6 px-one-line-data margin-bottom-2">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Resend Cognito Activation Email</h3>
      </div>
      {processState === 0 && (
        <>
          <TextField
            label="Tenant Id"
            size="small"
            value={tenantId}
            error={!tenantId}
            onChange={(e) => {
              setTenantId(e.target.value);
            }}
            placeholder="Tenant ID"
            className="margin-right-1"
          />
          <TextField
            label="Tenant Email"
            size="small"
            value={tenantEmail}
            error={!isEmail(tenantEmail)}
            onChange={(e) => {
              setTenantEmail(e.target.value);
            }}
            placeholder="Tenant Email"
            className="margin-right-1"
          />
          <PrimaryButton
            onClick={() => {
              confirm({
                onConfirm: sendEmail,
              });
            }}
            disabled={!isEmail(tenantEmail) || !tenantId}
          >
            SEND
          </PrimaryButton>
        </>
      )}

      {processState === 1 && <Wait />}
      {processState === 2 && (
        <>
          <div className="margin-bottom-3">
            <JSONInput
              id={`jsonEditor`}
              theme="light_mitsuketa_tribute"
              locale={localeEn}
              placeholder={previewState}
              height="550px"
              width="100%"
              viewOnly={true}
              style={{ body: { fontSize: '16px' } }}
            />
          </div>
          <Alert severity="success" className="margin-bottom-3">
            Email sent succesfully!
          </Alert>
          <PrimaryButton onClick={() => setProcessState(0)}>Restart</PrimaryButton>
        </>
      )}
    </>
  );
};

export default ResendCognitoEmail;
